module.exports = __webpack_public_path__ + "img/device_icon_washing.853d8f74.svg";